import { render, staticRenderFns } from "./IDFinder.vue?vue&type=template&id=3a4d4ac5&scoped=true"
import script from "./IDFinder.vue?vue&type=script&lang=js"
export * from "./IDFinder.vue?vue&type=script&lang=js"
import style0 from "./IDFinder.vue?vue&type=style&index=0&id=3a4d4ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d4ac5",
  null
  
)

export default component.exports